export default __webpack_public_path__ + "static/media/me.7f4aac5e.png";